@if (isOwnCollection) {
    <div class="flex flex-col sm:flex-row gap-2 justify-center">
        <div class="flex flex-col w-[360px] sm:min-w-[360px] sm:max-w-[720px] gap-2 grow">
            <div class="font-bold border-b border-ponder-light border-opacity-10">
                Collection Import
            </div>
            <!-- Step 1 -->
            <div class="flex flex-col p-2 gap-2 bg-slate-100 rounded shadow">
                <div class="text-sm font-bold">
                    Step 1: Select a game.
                </div>
                <div class="flex flex-row gap-2 flex-wrap text-sm">
                    <button 
                        (click)="onGameSelected(gameTypes.Magic)"
                        class="p-2 bg-slate-50 rounded shadow-sm flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border hover:border-ponder-link"
                        [ngClass]="{ 'text-ponder-link border-ponder-link' : isGameSelected(gameTypes.Magic)}">
                        Magic
                    </button>
                    <!--
                    <button 
                        (click)="onGameSelected(gameTypes.Lorcana)"
                        class="p-2 bg-slate-50 rounded shadow-sm flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border hover:border-ponder-link"
                        [ngClass]="{ 'text-ponder-link border-ponder-link' : isGameSelected(gameTypes.Lorcana)}">
                        Lorcana
                    </button>
                    -->
                </div>
            </div>
            <!-- Step 2 -->
            <div class="flex flex-col p-2 gap-2 bg-slate-100 rounded shadow">
                <div class="text-sm font-bold">
                    Step 2: Select collection format.
                </div>
                <div class="flex flex-row gap-2 flex-wrap text-sm">
                    <button 
                        (click)="onFormatSelected(collectionFormats.Csv)"
                        class="p-2 bg-slate-50 rounded shadow-sm flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border hover:border-ponder-link"
                        [ngClass]="{ 'text-ponder-link border-ponder-link' : isFormatSelected(collectionFormats.Csv)}">
                        CSV (.csv)
                    </button>
                    <button 
                        (click)="onFormatSelected(collectionFormats.UrzaGatherer)"
                        class="p-2 bg-slate-50 rounded shadow-sm flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border hover:border-ponder-link"
                        [ngClass]="{ 'text-ponder-link border-ponder-link' : isFormatSelected(collectionFormats.UrzaGatherer)}">
                        Urza Gatherer (.ugs)
                    </button>
                </div>
                <import-collection-note [game]="importState.game" [format]="importState.collectionType"></import-collection-note>
            </div>
            <!-- Step 3 -->
            <div class="flex flex-col p-2 gap-2 bg-slate-100 rounded shadow">
                <div class="text-sm font-bold">
                    Step 3: Provide collection data.
                </div>
                <div class="flex flex-row gap-4 items-center">
                    <input #fileUploadInput (change)="onFileSelected(fileUploadInput)" type="file" class="hidden" [attr.accept]="validExtensions">
                    <button 
                        (click)="fileUploadInput.click()" 
                        class="text-sm p-2 bg-slate-50 rounded shadow-sm flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-400 hover:disabled:border-transparent hover:disabled:cursor-default" 
                        [attr.disabled]="!importState.collectionType ? true : undefined">
                        Select File
                    </button>
                    @if (importState.fileName) {
                        <div class="text-sm p-2 border rounded" [ngClass]="{ 'border-red-600 text-red-600' : fileSizeError || fileExtensionError, 'border-ponder-link text-ponder-link truncate' : !fileSizeError && !fileExtensionError }">
                            {{ importState.fileName }} ({{ importState.fileBytes | number }} bytes)
                        </div>
                    }
                </div>
                @if (fileSizeError) {
                    <div class="text-sm text-red-600 italic">
                        Invalid file size. Max size of 1MB (1,000,000 bytes).
                    </div>
                }
                @if (fileExtensionError) {
                    <div class="text-sm text-red-600 italic">
                        Invalid file type. Expected: '{{ validExtensions }}'
                    </div>
                }
            </div>
            <!-- Step 4 -->
            <div class="flex flex-col p-2 bg-slate-100 rounded shadow">
                <div class="text-sm font-bold">
                    Step 4: Select item action.
                </div>
                <div class="flex flex-col gap-2 text-sm p-2">
                    <div class="flex flex-row gap-2 items-center">
                        <input #skipItemsInput (change)="importState.skipCollected = skipItemsInput.checked" type="checkbox" checked="true">
                        <div>Skip items already in collection?</div>
                    </div>
                    <div class="flex flex-row gap-2 items-center">
                        <input #importOtherInput (change)="importState.importOther = importOtherInput.checked" type="checkbox">
                        <div>Import other items (decks, etc.)?</div>
                    </div>
                    <div class="flex flex-row gap-2 items-center">
                        <input #skipOtherInput (change)="importState.skipCollectedOther = skipOtherInput.checked" type="checkbox" checked="true">
                        <div>Skip other items if name already exists?</div>
                    </div>
                </div>
            </div>
            <!-- Import -->
            <div class="flex flex-row justify-end">
                <button
                    (click)="onImportClicked()"
                    class="flex flex-row items-center align-middle justify-center text-sm p-2 bg-slate-50 w-[12ch] h-8 rounded shadow-sm stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-400 hover:disabled:border-transparent hover:disabled:cursor-default" 
                    [attr.disabled]="!importState.fileName || fileSizeError || fileExtensionError || isImporting || isThrottled ? true : undefined">
                    @if (!isImporting) {
                        <div>Import</div>
                    } @else {
                        <busy-spin [small]="true"></busy-spin>
                    }
                </button>
            </div>
            @if (importFailure) {
                <div class="rounded border border-red-600 text-red-600 bg-slate-100 text-sm p-2">
                    Collection import failed 😔<br/>
                    {{ failureReason }}
                </div>
            }
            <!-- History -->
            <div class="font-bold border-b border-ponder-light border-opacity-10">
                Import History
            </div>
            <div class="flex flex-col gap-2">
                <import-collection-results></import-collection-results>
            </div>
        </div>
    </div>
} @else {

}